// extracted by mini-css-extract-plugin
export default {"imageWrapper":"social-link-preview-LinkPreviewImage__imageWrapper--2a3Mr","imageWrapperSmaller":"social-link-preview-LinkPreviewImage__imageWrapperSmaller--13yZ3"};